// ============================================
// TOUR - Persistencia de "usuario ya vio este tour"
// ============================================
// Reutilizable por cualquier módulo. Mismo mecanismo (localStorage) que
// `lastCajaCheck` en VentasPage — es la convención ya establecida en este
// proyecto para "no repetir un aviso", en vez de agregar un endpoint nuevo.
//
// La clave incluye `usuarioId` (no solo el navegador) porque un mismo
// dispositivo/terminal puede tener múltiples usuarios iniciando sesión a lo
// largo del día, y cada uno debe ver el tour una vez por su cuenta. Incluye
// también `version`: si el contenido del tour cambia de forma relevante,
// subir la versión hace que vuelva a mostrarse aunque el usuario ya haya
// visto una versión anterior.

import { useEffect, useState } from 'react';

const STORAGE_PREFIX = 'tour-seen';

function buildKey(usuarioId: string, tourId: string, version: string): string {
  return `${STORAGE_PREFIX}:${usuarioId}:${tourId}:${version}`;
}

export const useTourSeen = (usuarioId: string | undefined, tourId: string, version: string) => {
  // Arranca en `true` (no disparar nada) hasta confirmar el estado real,
  // para no auto-iniciar el tour en el instante antes de que usuarioId esté
  // disponible.
  const [seen, setSeen] = useState(true);

  useEffect(() => {
    if (!usuarioId) return;
    setSeen(localStorage.getItem(buildKey(usuarioId, tourId, version)) === '1');
  }, [usuarioId, tourId, version]);

  const markAsSeen = () => {
    if (!usuarioId) return;
    localStorage.setItem(buildKey(usuarioId, tourId, version), '1');
    setSeen(true);
  };

  return { seen, markAsSeen };
};
